import { useLocation, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment, useContext, useRef } from 'react';
import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { variablesGlobales } from '../../../configs/variables';
import { roleUser } from '../../../utils/roleUser';
import { LoadingView } from '../../../components/loading/Loading';


export function ReportesAcierta() {

    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [hasView, setHasView] = useState(false);
    const [initDate, setInitDate] = useState('');
    const [finishDate, setFinishDate] = useState('');
    const [urlReporte, setUrlReporte] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChangeInitdate = (event) => {
        setInitDate(event.target.value);
    };

    const handleChangeFinishdate = (event) => {
        setFinishDate(event.target.value);
    };

    const handleSubmit = async (e) => {
        handleClearStateAlert()
        e.preventDefault();
        setIsLoading(true);
        try {
            let response = await HttpRequest.reporteAcierta({ initDate, finishdate: finishDate });
            if (response.error === false) {
                setUrlReporte(response.message?.data);
                setInitDate('');
                setFinishDate('');
                handleOpenAlert('success', response.message?.message, true);
            } else {
                handleOpenAlert('error', response.message?.message, true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error.message, true);
        } finally {
            setIsLoading(false);
            setTimeout(() => {
                handleClearStateAlert();
            }, 6000);
        }
    }


    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                            setHasView(true);
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
    }, []);

    if (!hasView) {
        return (<span>Cargando...</span>)
    } else {
        return (
            <Fragment>
                {
                    viewalert ?
                        <>
                            <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                            <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                        </>
                        : <></>
                }

                <DashboardsBackOffice
                    name={'Admin'}
                    balance={0}
                    current8={true}
                    title={'Reporte Acierta'}
                    main={
                        <>
                            <form action="#" method="POST">
                                <div className='px-4 mt-3 py-5 bg-white sm:p-6'>

                                    <div className="col-span-8 sm:col-span-4">

                                        <div>
                                            <label
                                                htmlFor="initialdate"
                                                className="block text-sm font-medium"
                                            >
                                                Fecha inicial
                                            </label>
                                            <div>
                                                <input
                                                    value={initDate}
                                                    onChange={handleChangeInitdate}
                                                    type="date"
                                                    name="initialdate"
                                                    id="initialdate"
                                                    maxlength="40"
                                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                />
                                            </div>

                                            <label
                                                htmlFor="finishdate"
                                                className="block text-sm font-medium"
                                            >
                                                Fecha final
                                            </label>
                                            <div>
                                                <input
                                                    value={finishDate}
                                                    onChange={handleChangeFinishdate}
                                                    type="date"
                                                    name="finishdate"
                                                    id="finishdate"
                                                    maxlength="40"
                                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                />
                                            </div>
                                        </div>

                                        <span
                                            className="text-sm"
                                            style={{ color: "#fc3e58", fontStyle: "italic" }}
                                        >
                                            {''}
                                        </span>
                                    </div>

                                    <div className="md:w-56 pt-3 mt-3">
                                        <button
                                            disabled={isLoading}
                                            onClick={handleSubmit}
                                            type="button"
                                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                        >
                                            <div className="flex">
                                                {'Generar reporte'}
                                                <div className="grid content-center pl-2">{ }</div>
                                            </div>
                                        </button>
                                    </div>

                                    <div className="md:w-56 pt-3 mt-3">
                                        <span
                                            className="text-m"
                                        >
                                            {
                                                urlReporte ? <a onClick={() => setUrlReporte(null)} style={{ fontWeight: 'bold', textDecorationLine: 'underline' }} href={urlReporte}>Descargar reporte</a>
                                                    :
                                                    <></>
                                            }

                                        </span>
                                    </div>

                                    {
                                        isLoading && (
                                            <LoadingView text={"Generando reporte..."} />
                                        )
                                    }

                                </div>
                            </form>

                        </>
                    }
                />

            </Fragment>
        );
    }


}
